import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { NavigationService } from '../../../services/navigation.service';
import { LanguageService } from '../../../services/language.service';
import { AngularModule } from '../../../modules/angular.module';
import { ZorroModule } from '../../../modules/zorro.module';

@Component({
	selector: 'app-language-selector',
	standalone: true,
	imports: [AngularModule, ZorroModule],
	templateUrl: './language-selector.component.html',
	styleUrl: './language-selector.component.scss',
})
export class LanguageSelectorComponent {
	@Output('onChange') private onChangeEmitter: EventEmitter<string> = new EventEmitter<string>();
	@Input('changeSpokenLanguageOnSelect') public changeSpokenLanguageOnSelect: boolean = false;
	public selectedLanguage: string = this.languageService.spokenLanguage$.value;
	private sub: Subscription | undefined;

	constructor(public nav: NavigationService, public languageService: LanguageService) {
		this.sub = this.languageService.spokenLanguage$.subscribe((languageCode: string) => {
			this.selectedLanguage = languageCode;
		});
	}

	ngOnInit(): void {}

	public selectLanguage(languageCode: string): void {
		if (this.changeSpokenLanguageOnSelect) {
			this.languageService.selectSpokenLanguage(languageCode);
		}

		this.selectedLanguage = languageCode;

		this.onChangeEmitter.emit(languageCode);
	}

	ngOnDestroy(): void {
		if (this.sub) {
			this.sub.unsubscribe();
		}
	}
}
